// @ts-ignore
import * as FireStoreParser from 'firestore-parser';
import { firebaseConfig } from '../config';

import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import {deepCopy} from "../utils/deep-copy";
import {LiveaboardPackagesInterface, ResortPackagesInterface, DiveShopPackagesInterface} from "../types/package";

const {projectId} = firebaseConfig;


export interface PackagesResponse {
    liveaboard: LiveaboardPackagesInterface,
    resort: ResortPackagesInterface,
    diveshop: DiveShopPackagesInterface
}

// Define a service using a base URL and expected endpoints
export const firestoreApi = createApi({
    reducerPath: 'firestoreSlice',
    baseQuery: fetchBaseQuery({ baseUrl: `https://firestore.googleapis.com/v1/projects/${projectId}/databases/(default)/documents/` }),
    endpoints: (builder) => ({
        getForexByCurrency: builder.query<any, string>({
            query: (name) => `forex/${name}`,
            transformResponse: async (response) => {

                // NOTE: there's a "special" currency called "0info" which contains lastUpdated and apiTimestamp

                const parsedResponse = await FireStoreParser(response)

                const info = deepCopy(parsedResponse.fields["0info"])
                delete parsedResponse.fields["0info"]

                return {
                    rates: parsedResponse.fields,
                    info
                }
            }
        }),
        getPackagesByTripId: builder.query<PackagesResponse, string>({
            query: (tripId) => `packages/${tripId}`,
            transformResponse: async (response) => {

                const {
                    liveaboard,
                    resort,
                    diveshop
                } = await FireStoreParser(response).fields;

                return {
                    liveaboard,
                    resort,
                    diveshop
                }
            }
        }),
    }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useGetPackagesByTripIdQuery,
    useGetForexByCurrencyQuery
} = firestoreApi
